import { bindUrl, request } from "./request";

export function getCompanyList(queryParams) {
  return request({
    url: bindUrl("/svc-abns/company/list", {}),
    method: "GET",
    params: queryParams
  });
}

export function getEcho(queryParams) {
  return request({
    url: bindUrl("/svc-abns/company/echo", {}),
    method: "GET",
    params: queryParams
  });
}

export function submit(bodyParams) {
  return request({
    url: bindUrl("/svc-abns/company/submit", {}),
    method: "POST",
    data: bodyParams
  });
}

export function getCompanyDetail(queryParams) {
  return request({
    url: bindUrl("/svc-abns/company/detailById", {}),
    method: "GET",
    params: queryParams
  });
}

export function getContactList(queryParams) {
  return request({
    url: bindUrl("/svc-abns/trader/company/listCompanyUserList", {}),
    method: "GET",
    params: queryParams
  });
}

export function update(bodyParams) {
  return request({
    url: bindUrl("/svc-abns/company/update", {}),
    method: "POST",
    data: bodyParams
  });
}

export function submitShanghaiAuthorization(bodyParams) {
  return request({
    url: bindUrl("/svc-abns/company/submitShanghaiAuthorization", {}),
    method: "POST",
    data: bodyParams
  });
}
